var React = require('react');

var $ = require("jquery");

var ReactDOM = require('react-dom');

var _ = require("underscore");

var HotelOrderDialog = require('./HotelOrderDialog');

var { get_productDescribeList } = require('../util/productDescribeService');

var visaHintInfo = require("../conf/visa-hint-info");

var InsuranceClauseDialog = require("./InsuranceClauseDialog");
var NoAppinotDialog =  require("./NoAppinotDialog");
var noAppointRoomKind =true;

/**
 * 处理 extra 的 map
 */
var mapExtraProps = function (data,iteratee) {

    if(!_.isObject(data)){
       return null
    }

    return iteratee( data )

};

/**
 * 备注信息
 */
var RemarksDescribe = ({remarks})=>
    remarks && remarks.length
        ?
            <ul className="remarks">
            {
                remarks.map( (remark, index)=>
                     <li className="item" key={index} dangerouslySetInnerHTML={{__html: remark}}></li>)
            }
            </ul>
        :   <noscript/>

/**
 * 签证查看链接
 */
var VisaBtn = ({poi_id,poi_name})=>
    poi_id ? <div className="visa-hint">
              <a className="btn-primary"
                href={`//www.xcds.com.cn/topic/special/visa-${poi_id}-pc_h5/`}>查看{ poi_name }签证办理注意事项</a>
                { 
                  visaHintInfo(poi_id) ? <p className="info"><em>* { visaHintInfo(poi_id) }</em></p> : <noscript/>
                }
             </div>
        : <noscript/>

/**
 * 提示信息
 */
var ProductTips = ({tips})=>
    tips? <p className="info">* { tips }</p>
        : <noscript/>

/**
 * 商品描述信息并带有数目统计
 * @param {object} props
 * @param {object} props.data - 商品的数据
 * @param {string} props.productType - 商品的类型
 * @param {string} props.hasFullName - 是否显示全名
 */
var ProductDescribe= ({ data, productType, tips, hasFullName ,hasNum })=>
    <ul className="item-list">
        {
            get_productDescribeList(data, productType).map( ({pid, name,name_tags,fullName,num,remarks,extra,notices}, index) =>

                <li className="item" key={index}  >
                    <span className="item-name" dangerouslySetInnerHTML={{__html: hasFullName? fullName : name}}></span>
                    {
                        name_tags ? (
                            _.map(name_tags,function(item,index){
                               return (<span className="item-num" key = {"spec-" + index}>{ item }</span>)  
                            })
                        ) : null
                    }
                    {
                        hasNum && productType
                            ?<span className="item-num">{ num }</span>
                            : null
                    }
                    <RemarksDescribe remarks={ remarks }  />
                    {
                        mapExtraProps(extra, ({poi_id,poi_name})=> <VisaBtn poi_id={ poi_id } poi_name={ poi_name } /> )
                    }
                    {
                      productType == "insurance" ?
                        <InsuranceClauseDialog pid={ pid } pname={ name } />
                        : null
                    }

                    {notices ?(
                        <div>
                        {
                            notices.tips?(
                                <dl className="cell-serve-standard cell-serve-standard-span">
                                    <dt> {notices.title}</dt>
                                    <dd>
                                        <ul>
                                        {

                                            _.map(notices.tips, function(item,index) {
                                                return(
                                                    <li key={index}>
                                                        <span className="title">{item.k} ：</span>
                                                        <span>{item.v}</span>
                                                    </li>
                                                )
                                            })


                                        }
                                        </ul>
                                     </dd>
                                </dl>        
                             ):null
                        }

                        {
                            notices.special_desc ? (

                                <dl className="cell-serve-standard cell-serve-standard-span">
                
                                    <dd>
                                        
                                            {

                                                _.map(notices.special_desc,function(n,i){
                                                    return(

                                                        <p key={"spec-" + i} >
                                                            
                                                            <span> {n} </span>
                                                        </p>    
                                                    )
                                                })
                                            }
                                        
                                    </dd>
                                </dl>       
                            ) : null     
                        }

                        {
                            notices.special_tips_list ? (
                                <div>
                                 
                                {
                                    _.map(notices.special_tips_list,function(e,j){
                                        return(
                                            <dl className="cell-serve-standard cell-serve-standard-span" key={"spectip-" + j}>
            
                                                <dd>
                                                    <p className='title'>
                                                        {e.title}
                                                    </p> 
                                                     <p  >
                                                        {e.desc}
                                                    </p>  
                                                 </dd>
                                             </dl>
                                            
                                        )
                                    })
                                                   
                                }
                                </div>
                                             
                            ) : null  

                        }    
                               
                    
                </div>
                ): null}

                </li>

            )
        }
        <li>
            <ProductTips tips={tips} />
        </li>
    </ul>

/**
 * 详细的商品描述信息包括天数,名称,总数,备注
 * @param {object} props
 * @param {object} props.data - 商品的数据
 * @param {string} props.productType - 商品的类型
 * @param {string} props.hasFullName - 是否显示全名
 */
var ProductDescribeDetail = ({data, productType, tips, hasFullName, hasNum})=>

    <ul className="item-list">
        {
            get_productDescribeList(data, productType).map(({day, name,name_tags, fullName, num, remarks,notices}, index)=>

                <li className="item" key={ index }>
                    <div className="day">
                        <span className="lab">
                            <em>{ day }</em>
                        </span>
                        <span className="item-name" dangerouslySetInnerHTML={{__html: hasFullName? fullName : name}}></span>
                        {
                            name_tags ? (
                                _.map(name_tags,function(item,index){
                                   return (<span className="item-num" key = {"spec-" + index}>{ item }</span>)  
                                })
                            ) : null
                        }
                        {
                            hasNum && productType && num ?<span className="item-num">{ num }</span> : null
                        }
                        
                        <RemarksDescribe remarks={ remarks }  />
                    </div>

                    {notices ?(
                        <div>
                        {
                            notices.tips?(
                                <dl className="cell-serve-standard cell-serve-standard-span">
                                    <dt> {notices.title}</dt>
                                    <dd>
                                        <ul>
                                        {

                                            _.map(notices.tips, function(item,index) {
                                                return(
                                                    <li key={index}>
                                                        <span className="title">{item.k} ：</span>
                                                        <span>{item.v}</span>
                                                    </li>
                                                )
                                            })


                                        }
                                        </ul>
                                     </dd>
                                </dl>        
                             ):null
                        }

                        {
                            notices.special_desc ? (

                                <dl className="cell-serve-standard cell-serve-standard-span">
                
                                    <dd>
                                        
                                            {

                                                _.map(notices.special_desc,function(n,i){
                                                    return(

                                                        <p key={"spec-" + i} >
                                                            
                                                            <span> {n} </span>
                                                        </p>    
                                                    )
                                                })
                                            }
                                        
                                    </dd>
                                </dl>       
                            ) : null     
                        }

                        {
                            notices.special_tips_list ? (
                                <div>
                                 
                                {
                                    _.map(notices.special_tips_list,function(e,j){
                                        return(
                                            <dl className="cell-serve-standard cell-serve-standard-span" key={"spectip-" + j}>
            
                                                <dd>
                                                    <p className='title'>
                                                        {e.title}
                                                    </p> 
                                                     <p  >
                                                        {e.desc}
                                                    </p>  
                                                 </dd>
                                             </dl>
                                            
                                        )
                                    })
                                                   
                                }
                                </div>
                                             
                            ) : null  

                        }    
                               
                    
                </div>
                ): null}

                </li>
            )
        }
        <li>
            <ProductTips tips={tips} />
        </li>
    </ul>

var HotelDescribeDetailA = ({data, productType, tips, hasFullName, hasNum})=>

        <ul className="item-list">
            {
                get_productDescribeList(data, productType).map(({day, name,name_tags,fullName, num, remarks,notices,person}, index)=>

                        <li className="item" key={ index }>
                            <div className="day">
                        <span className="lab">
                            <em>{ day }</em>
                        </span>
                                <span className="item-name" dangerouslySetInnerHTML={{__html: hasFullName? fullName : name}}></span>
                                {
                                    name_tags ? (
                                        _.map(name_tags,function(item,index){
                                           return (<span className="item-num" key = {"spec-" + index}>{ item }</span>)  
                                        })
                                    ) : null
                                }
                                {
                                    hasNum && productType && num ?<span className="item-num">{ num }</span> : null
                                }
                                <RemarksDescribe remarks={ remarks }  />
                            </div>

                           {notices ?(
                                <div>
                                {
                                    notices.tips?(
                                        <dl className="cell-serve-standard cell-serve-standard-span">
                                            <dt> {notices.title}</dt>
                                            <dd>
                                                <ul>
                                                {

                                                    _.map(notices.tips, function(item,index) {
                                                        if(item.k == "指定房型"){noAppointRoomKind = false}
                                                        return(
                                                            <li key={index}>
                                                                <span className="title">{item.k} ：</span>
                                                                <span>{item.v}</span>
                                                            </li>
                                                        )
                                                    })

                                                }
                                                </ul>
                                             </dd>
                                        </dl>        
                                     ):null
                                }

                                {
                                    notices.special_desc ? (

                                        <dl className="cell-serve-standard cell-serve-standard-span">
                        
                                            <dd>
                                                
                                                    {

                                                        _.map(notices.special_desc,function(n,i){
                                                            return(

                                                                <p key={"spec-" + i} >
                                                                    
                                                                    <span> {n} </span>
                                                                </p>    
                                                            )
                                                        })
                                                    }
                                                
                                            </dd>
                                        </dl>       
                                    ) : null     
                                }

                                {
                                    notices.special_tips_list ? (
                                        <div>
                                         
                                        {
                                            _.map(notices.special_tips_list,function(e,j){
                                                return(
                                                    <dl className="cell-serve-standard cell-serve-standard-span" key={"spectip-" + j}>
                    
                                                        <dd>
                                                            <p className='title'>
                                                                {e.title}
                                                            </p> 
                                                             <p  >
                                                                {e.desc}
                                                            </p>  
                                                         </dd>
                                                     </dl>
                                                    
                                                )
                                            })
                                                           
                                        }
                                        </div>
                                                     
                                    ) : null  

                                }     
                                       
                            
                        </div>
                        ): null}

                            {noAppointRoomKind && index == data.length-1 && person ? (
                                    <dl className="cell-serve-standard">
                                        <dd>
                                            {person[1] == "0" ? (
                                                    <span>
                                您未指定房型（大床房、双床房等）。在预定时填写的房型偏好仅能视住宿库存等因素而定，无法100%保证。如您对房型有严格要求，请联系旅行顾问指定，指定后价格很可能发生变化。</span>): (
                                                    <span>
                                此住宿为儿童不占床、不加床的价格，如要占床、可加床房型（加床后可能拥挤），请联系旅行顾问指定。入住时现场加床或升级房型，住宿方会视房型、库存等因素才能决定，由此产生的费用须由您现场支付，行程大师无法提前代缴。
                                </span>)    }
                                            <NoAppinotDialog/>

                                <span>

                                </span>
                                        </dd>
                                    </dl>
                            ):null
                            }

                        </li>
                )
            }
            <li>
                <ProductTips tips={tips} />
            </li>
        </ul>
/**
 * 判断机票是否为内陆航段
 */
var isInland = function (extra) {

    if( !_.isObject(extra) || typeof extra.inland === 'undefined' ){
        return false
    }

    return !!extra.inland

};

/**
 * 机票描述信息
 * @param {object} props
 * @param {object} props.data - 商品的数据
 * @param {string} props.plantInfo - 机票信息
 */
var AirTicketDescribe = ({data,hasNum})=>
    <ul className="item-list">
        {
            get_productDescribeList(data, 'air').map(({day, name,name_tags, num, remarks, extra,notices}, index)=>

                <li className="item" key={ index }>
                    {
                        isInland(extra) && day && <span className="item-day">{ day }</span>
                    }
                    <span className="item-name" dangerouslySetInnerHTML={{__html: name}}></span>
                    {
                        hasNum && num ?<span className="item-num">{ num }</span> : null
                    }
                    {
                        name_tags ?<span className="item-num">{ name_tags }</span> : null
                    }
                    {
                        ! isInland(extra) && name_tags=="严选" ? <span className="extra-tips">(单程转机次数≤1次)</span> : null
                    }
                    <RemarksDescribe remarks={ remarks }  />

                    {notices ?(
                        <div>
                        {
                            notices.tips?(
                                <dl className="cell-serve-standard cell-serve-standard-span">
                                    <dt> {notices.title}</dt>
                                    <dd>
                                        <ul>
                                        {

                                            _.map(notices.tips, function(item,index) {
                                                return(
                                                    <li key={index}>
                                                        <span className="title">{item.k} ：</span>
                                                        <span>{item.v}</span>
                                                    </li>
                                                )
                                            })


                                        }
                                        </ul>
                                     </dd>
                                </dl>        
                             ):null
                        }

                        {
                            notices.special_desc ? (

                                <dl className="cell-serve-standard cell-serve-standard-span">
                
                                    <dd>
                                        
                                            {

                                                _.map(notices.special_desc,function(n,i){
                                                    return(

                                                        <p key={"spec-" + i} >
                                                            
                                                            <span> {n} </span>
                                                        </p>    
                                                    )
                                                })
                                            }
                                        
                                    </dd>
                                </dl>       
                            ) : null     
                        }

                        {
                            notices.special_tips_list ? (
                                <div>
                                 
                                {
                                    _.map(notices.special_tips_list,function(e,j){
                                        return(
                                            <dl className="cell-serve-standard cell-serve-standard-span" key={"spectip-" + j}>
            
                                                <dd>
                                                    <p className='title'>
                                                        {e.title}
                                                    </p> 
                                                     <p  >
                                                        {e.desc}
                                                    </p>  
                                                 </dd>
                                             </dl>
                                            
                                        )
                                    })
                                                   
                                }
                                </div>
                                             
                            ) : null  

                        }    
                               
                    
                </div>
                ): null}

                </li>
            )
        }
    </ul>

/**
 * 酒店的商品描述,增添了酒店清单的弹框,不显示商品数量
 * @param {object} props
 * @param {object} props.data - 商品的数据
 */
var HotelDescribeDetail = ({data,hasNum})=>
    <ul className="item-list">
        {
            get_productDescribeList(data, 'hotel').map(({day, name,name_tags, num, remarks, extra,notices,person}, index)=>

                <li className="item" key={ index }>
                    <div className="day">
                        <span className="lab">
                            <em>{ day }</em>
                        </span>
                        <span className="item-name" dangerouslySetInnerHTML={{__html: name}}></span>
                        {
                            name_tags ? (
                                _.map(name_tags,function(item,index){
                                   return (<span className="item-num" key = {"spec-" + index}>{ item }</span>)  
                                })
                            ) : null
                        }
                        {
                            hasNum && num ?<span className="item-num">{ num }</span> : null
                        }
                        <HotelOrderDialog hotelList={ extra }></HotelOrderDialog>
                        <RemarksDescribe remarks={ remarks }  />
                    </div>
                    
                    {notices ?(
                        <div>
                        {
                            notices.tips?(
                                <dl className="cell-serve-standard cell-serve-standard-span">
                                    <dt> {notices.title}</dt>
                                    <dd>
                                        <ul>
                                        {

                                            _.map(notices.tips, function(item,index) {
                                                if(item.k == "指定房型"){noAppointRoomKind = false}
                                                return(
                                                    <li key={index}>
                                                        <span className="title">{item.k} ：</span>
                                                        <span>{item.v}</span>
                                                    </li>
                                                )
                                            })


                                        }
                                        </ul>
                                     </dd>
                                </dl>        
                             ):null
                        }

                        {
                            notices.special_desc ? (

                                <dl className="cell-serve-standard cell-serve-standard-span">
                
                                    <dd>
                                        
                                            {

                                                _.map(notices.special_desc,function(n,i){
                                                    return(

                                                        <p key={"spec-" + i} >
                                                            
                                                            <span> {n} </span>
                                                        </p>    
                                                    )
                                                })
                                            }
                                        
                                    </dd>
                                </dl>       
                            ) : null     
                        }

                        {
                            notices.special_tips_list ? (

                                <div>
                                 
                                {
                                    _.map(notices.special_tips_list,function(e,j){
                                        return(
                                            <dl className="cell-serve-standard cell-serve-standard-span" key={"spectip-" + j}>
            
                                                <dd>
                                                    <p className='title'>
                                                        {e.title}
                                                    </p> 
                                                     <p  >
                                                        {e.desc}
                                                    </p>  
                                                 </dd>
                                             </dl>
                                            
                                        )
                                    })

                                }
                                </div>
                                             
                            ) : null  

                        }    
                               
                    
                </div>
                ): null}

                    {noAppointRoomKind && index == data.length-1 && person? (
                        <dl className="cell-serve-standard">
                            <dd>
                                {person[1] == "0" ? (
                                        <span>
                                您未指定房型（大床房、双床房等）。在预定时填写的房型偏好仅能视住宿库存等因素而定，无法100%保证。如您对房型有严格要求，请联系旅行顾问指定，指定后价格很可能发生变化。</span>): (
                                        <span>
                                此住宿为儿童不占床、不加床的价格，如要占床、可加床房型（加床后可能拥挤），请联系旅行顾问指定。入住时现场加床或升级房型，住宿方会视房型、库存等因素才能决定，由此产生的费用须由您现场支付，行程大师无法提前代缴。
                                </span>)    }
                                <NoAppinotDialog/>

                                <span>

                                </span>
                            </dd>
                        </dl>
                    ):null
                    }

                </li>
            )
        }
    </ul>

module.exports = {
    ProductTips,
    ProductDescribe,
    ProductDescribeDetail,
    AirTicketDescribe,
    HotelDescribeDetail,
    HotelDescribeDetailA
};



/** WEBPACK FOOTER **
 ** ./script/detail-m/ProductDescribe.jsx
 **/